import { render, staticRenderFns } from "./FollowDoctorList.vue?vue&type=template&id=7f309454&scoped=true&"
import script from "./FollowDoctorList.vue?vue&type=script&lang=js&"
export * from "./FollowDoctorList.vue?vue&type=script&lang=js&"
import style0 from "./FollowDoctorList.vue?vue&type=style&index=0&id=7f309454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f309454",
  null
  
)

export default component.exports